export class Authen {
    UserName: string = null;
    UserType: string = null;
    PrnCode: string = null;
    GroupUserCode: string = null;
    UserNameInternal: string = null;

    public set(p: any) {
        this.UserName = p.UserName;
        this.UserType = p.UserType;
        this.PrnCode = p.PrincipalCode;
        this.GroupUserCode = p.GroupUserCode;
        this.UserNameInternal = p.UserNameInternal;
    }

    public reset() {
        this.UserName = null;
        this.UserType = null;
        this.PrnCode = null;
        this.GroupUserCode = null;
        this.UserNameInternal = null;
    }
}
